export default __webpack_public_path__ + "static/media/099-yak.91e9a2fb.svg";